import React, { Component } from "react";
import { connect } from "react-redux";

class WizardProgress extends Component {
    render() {
        const { steps } = this.props;

        return <section className="wizard-progress-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <ul className="process-stepper clearfix" data-process-steps={steps.length}>
                            {steps}
                        </ul>
                    </div>
                </div>
            </div>
        </section>;
    }
}

export default connect()(WizardProgress);
